export default __webpack_public_path__ + "static/media/image17.a9e177ce.png";